import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import data from "../data";
import styles from "./styles.module.scss";
import ProductTile from "../ProductTile";
import H2Font from "Root/profile/components/common/H2Font";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import { AddUserCartItemThunk, LoadUserCartThunk } from "Root/profile/redux/thunkCreators/products/userCart";
import { LoadPricingThunk } from "Root/profile/redux/thunkCreators/orders/pricing";
const UpsellSection = ({ toExclude }) => {
    const { systemStarters, performanceBoosts, accessories } = data;
    const history = useHistory();
    const dispatch = useDispatch();
    const filteredStarters = systemStarters.filter((item) => {
        if (Array.isArray(toExclude)) {
            return !toExclude.includes(item.item_id);
        }
        return item.item_id !== toExclude;
    });
    const filteredBoosts = performanceBoosts.filter((item) => {
        if (Array.isArray(toExclude)) {
            return !toExclude.includes(item.item_id);
        }
        return item.item_id !== toExclude && item.item_id !== "fiber";
    });
    const filteredAccessories = accessories.filter((item) => {
        if (Array.isArray(toExclude)) {
            return !toExclude.includes(item.item_id);
        }
        return item.item_id !== toExclude;
    });
    const addToCartHandler = async (product) => {
        if (["wb221", "blenderbottle"].includes(product)) {
            await dispatch(AddUserCartItemThunk(product));
            await dispatch(LoadUserCartThunk());
            await dispatch(LoadPricingThunk());
            return;
        }
        history.push(`/app/products/${product}/`);
    };
    return (_jsx(_Fragment, { children: _jsxs("div", { className: styles.wrapper, children: [_jsx(H2Font, { fontWeight: 400, children: "Complete Your System" }), _jsxs("div", { className: styles.itemwrapper, children: [filteredStarters.map((product, i) => (_jsx(ProductTile, { addToCartHelper: addToCartHandler, href: `/app/products/${product}/`, showCta: true, ...product }, product.item_id))), filteredBoosts.map((product, i) => (_jsx(ProductTile, { addToCartHelper: addToCartHandler, href: `/app/products/${product}/`, showCta: true, ...product }, product.item_id)))] })] }) }));
};
export default UpsellSection;
